module.exports = __webpack_public_path__ + "static/media/default.f4305c42.png";